if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /* Update premium
        *
        * Update the premium on change of insurance choices
        *
        * */
        ZZ.UpdatePremium = function(premiumContainer) {
            var base = this;
            base.premiumContainer = premiumContainer;
            base.form = base.premiumContainer.parents("form:first");
            base.formFields = base.form.find(":input");
            base.url = base.premiumContainer.attr("data-url");

            base.assignListeners();
        };

        ZZ.UpdatePremium.prototype = {
            assignListeners: function() {
                var base = this;
                base.formFields.on("change", function() {
                    base.update();
                });
            },

            update: function() {
                var base = this;
                var method = base.form.attr("method") || "GET";
                base.premiumContainer.addClass("loading");
                $.ajax({
                    url: base.url,
                    dataType: "json",
                    type: method,
                    data: base.form.serialize(),
                    redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,
                    success: function(response) {
                        base.premiumContainer.removeClass("loading");
                        var infoContainer = base.premiumContainer.find(
                            ".information"
                        );
                        infoContainer.html(
                            "<span>" + response.result + "</span>"
                        );
                        if (typeof response.note !== "undefined") {
                            infoContainer.append(
                                "<p>" + response.note + "</p>"
                            );
                        }
                        $(window).trigger(
                            "zz_premium_update",
                            response.premium
                        );
                    },
                    error: function() {
                        base.premiumContainer.removeClass("loading");
                        base.premiumContainer.find(".information").html("");
                    }
                });
            }
        };
    })(jQuery);
}
